export default __webpack_public_path__ + "static/media/w95fa.a79f0836.woff";